/**
 * Screen transitions — a cheap black fade over the hard `location.href` page swaps
 * between the menu / game / editor entry points (Tier 2 polish). Presentation-only
 * (no engine coupling). `fadeIn` runs at boot; `navigate` fades OUT then swaps the page.
 */

function cover(): HTMLDivElement {
  let c = document.getElementById('sr-fade') as HTMLDivElement | null;
  if (!c) {
    c = document.createElement('div');
    c.id = 'sr-fade';
    Object.assign(c.style, {
      position: 'fixed', top: '0', left: '0', right: '0', bottom: '0', zIndex: '2000',
      background: '#12141c', opacity: '0', pointerEvents: 'none', transition: 'opacity 220ms ease',
    } as Partial<CSSStyleDeclaration>);
    document.body.appendChild(c);
  }
  return c;
}

/** Fade the black cover out on page load (call once at app boot). */
export function fadeIn(ms = 240): void {
  const c = cover();
  c.style.transition = `opacity ${ms}ms ease`;
  c.style.opacity = '1';
  // next frame → fade to transparent, then stop intercepting.
  requestAnimationFrame(() => requestAnimationFrame(() => {
    c.style.opacity = '0';
    window.setTimeout(() => { c.style.pointerEvents = 'none'; }, ms);
  }));
}

/** Fade to black, then navigate to `url` (replaces a bare `location.href = url`). */
export function navigate(url: string, ms = 220): void {
  const c = cover();
  c.style.transition = `opacity ${ms}ms ease`;
  c.style.pointerEvents = 'auto';
  requestAnimationFrame(() => { c.style.opacity = '1'; });
  window.setTimeout(() => { location.href = url; }, ms);
}
